<script>
  export let closeAbout;
  import { fly } from "svelte/transition";
</script>

<div
  class="about-container w-100 h-100 bg-custom-yellow absolute top-0 left-0 z-2 pl4 pt4 pr4 pb0 flex flex-column"
  transition:fly={{
    duration: 250,
    x: window.innerWidth,
    opacity: 0.5,
  }}
>
  <div class="flex w-100 items-center mb3">
    <button on:click={closeAbout} class="ma0 pa0"
      ><img src="./icones/back.svg" alt="" /></button
    >
    <h2 class="pa0  ma0 ml3">À propos</h2>
  </div>

  <p class="lh-copy f4 h-100 overflow-scroll pt0 mt0 mb0 pb4">
    <i>Bureaucratics: Augmented photography</i> est une installation interactive
    imaginée pour les 40 ans de l'IDHEAP en 2021. <br />
    Pour cette occasion, une collection de clichés appartenant à l’IDHEAP ont été
    "augmentées" par un algorithme d'intelligence artificielle afin qu'on puisse
    visualiser celles-ci en trois dimensions.<br />
    Cette série de 10 images du photographe Jan Banning est issue de son projet
    <i>Bureaucratics</i>
    qui l’a emmené autour du monde pour photographier des fonctionnaires de l’administration
    publique dans leur environnement de travail.<br />
    Chacune de ces photographies est détaillée et agrémentée d'anecdotes sur l'IDHEAP.
  </p>
</div>

<style>
  .about-container {
    position: fixed;
  }

  button {
    background: transparent;
    width: 48px;
    height: 48px;
    flex-shrink: 0;
    align-self: flex-end;
  }

  button img {
    width: 48px;
    height: 48px;
  }
</style>
